import React from "react";

export default (props) => (
  <div className="card-header">
    <h3 className="card-title">
      <i className={`hidden-xs fa ${props.icon}`}></i>
      {`  ${props.title}`}
    </h3>

    {props.searchVisible ? (
      <div className="card-tools">
        <div className="input-group input-group-sm" style={{ width: 200 }}>
          <input
            ref={props.searchRef}
            onChange={props.onChange}
            type="text"
            name="table_search"
            className="form-control float-right"
            placeholder="Pesquisar"
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-default">
              <i className="fa fa-search" />
            </button>
          </div>
        </div>
      </div>
    ) : null}
  </div>
);
